// ModalRegister.jsx
import React, {
  useState,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { toast } from "react-toastify";
// primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { TabPanel, TabView } from "primereact/tabview";
// components
import Modal from "../Modal";
import { Bond } from "./content/Bond";
import { Access } from "./content/Access";
import { Address } from "./content/Address";
import { Documents } from "./content/Documents";
import { PersonalData } from "./content/personalData/PersonalData";
//services
import { getFormClientConfig } from "../../../services/GeneralRegistration/getFormClientConfig";

const ModalRegister = forwardRef(
  (
    {
      file,
      bond,
      spouse,
      errors,
      onHide,
      access,
      visible,
      setFile,
      loading,
      address,
      setBond,
      contacts,
      baseData,
      accessId,
      setSpouse,
      documents,
      setAccess,
      emailSend,
      setAddress,
      telephones,
      setVisible,
      editClient,
      setContacts,
      emailVerify,
      typeRegister,
      personalData,
      handleSubmit,
      loadingModal,
      setDocuments,
      handleUpdate,
      showInputCrc,
      setTelephones,
      errorsVisible,
      showInputCreci,
      setPersonalData,
      setShowInputCrc,
      setTypeRegister,
      setErrorsVisible,
      setShowInputCreci,
    },
    ref
  ) => {
    const [completed, setCompleted] = useState({
      access: !!access,
      personal: !!personalData,
      address: !!address,
    });
    const [cpf, setCpf] = useState("");
    const [activeIndex, setActiveIndex] = useState(0);
    const [proofResidence, setProofResidence] = useState("");
    const [socialContract, setSocialContract] = useState("");
    const [inputRequireds, setInputRequireds] = useState([]);
    const [showStatusUser, setShowStatusUser] = useState(false);
    const [cumulativeTooltip, setCumulativeTooltip] = useState(2);
    const bondRef = useRef(null);
    const accessRef = useRef(null);
    const addressRef = useRef(null);
    const personalRef = useRef(null);
    const documentsRef = useRef(null);

    useImperativeHandle(ref, () => ({
      handleSave,
    }));

    const validateRequiredFields = (data, fields) => {
      const missingFields = fields.filter((field) => {
        const value = data[field];
        return value === undefined || value === null || value === "";
      });

      if (missingFields.length > 0) {
        toast.error("Preencha todos os campos obrigatórios!");
        return false;
      }
      return true;
    };

    const handleAccessSubmit = (data) => {
      const requiredFields = inputRequireds.filter((field) =>
        ["email"].includes(field)
      );

      const isValid = validateRequiredFields(data, requiredFields);
      if (!isValid) return;

      if (
        data.registration_types === undefined &&
        data.access_id === undefined
      ) {
        toast.warn("Adicione um tipo de cadastro ou um grupo de acesso!");
        return;
      }

      if (data.confirmEmail || data.email) {
        if (data.confirmEmail !== data.email) {
          toast.error("Os E-mails devem ser iguais!");
          return;
        }
      }

      markComplete("access");
      setAccess(data);
      setActiveIndex((i) => i + 1);
    };

    const handlePersonalSubmit = (data) => {
      const alwaysRequired = ["name", "doc"];
      const dynamicRequired = inputRequireds.filter((field) =>
        [
          "rg",
          "date_of_birth",
          "profession",
          "name_mother",
          "name_father",
          "issuing_authority",
          "nationality",
          "obs",
          "creci",
          "family_income",
        ].includes(field)
      );
      // console.log("data", data);

      const requiredFields = [...alwaysRequired, ...dynamicRequired];

      const isValid = validateRequiredFields(data, requiredFields);
      if (!isValid) return;

      markComplete("personal");
      setPersonalData(data);
      setActiveIndex((i) => i + 1);
    };

    const handleAddressSubmit = (data) => {
      const requiredFields = inputRequireds.filter((field) =>
        [
          "cep",
          "address",
          "num",
          "neighborhood",
          "city",
          "state",
          "complement",
        ].includes(field)
      );

      const isValid = validateRequiredFields(data, requiredFields);
      if (!isValid) return;

      markComplete("address");
      setAddress(data);
      setActiveIndex((i) => i + 1);
    };

    const handleClickEditErrors = (form) => {
      console.log(errors);
      if (errors.email || errors.creci) {
        setActiveIndex(0);
        setErrorsVisible(false);
      } else if (errors.name) {
        setActiveIndex(1);
        setErrorsVisible(false);
      } else if (errors.doc) {
        setActiveIndex(1);
        setErrorsVisible(false);
      } else if (
        errors.rg ||
        errors.profession ||
        errors.name_father ||
        errors.name_mother ||
        errors.nationality ||
        errors.date_of_birth ||
        errors.family_income ||
        errors.issuing_authority ||
        errors.date_issuing_authority ||
        errors["contacts.0.type_number"] ||
        errors["contacts.1.type_number"] ||
        errors["contacts.2.type_number"]
      ) {
        setActiveIndex(1);
        setErrorsVisible(false);
      } else if (errors.contacts || errors.obs) {
        setActiveIndex(1);
        setErrorsVisible(false);
      } else if (errors.documents) {
        setActiveIndex(3);
        setErrorsVisible(false);
      } else if (
        errors["addresses.complement"] ||
        errors["addresses.address"] ||
        errors["addresses.neighborhood"] ||
        errors["addresses.city"] ||
        errors["addresses.num"] ||
        errors["addresses.state"] ||
        errors["addresses.cep"]
      ) {
        setActiveIndex(2);
        setErrorsVisible(false);
      }
    };

    const handleInputRequired = async () => {
      const response = await getFormClientConfig();
      if (Array.isArray(response)) {
        localStorage.setItem("registerGeneral", response);
      }
    };

    const markComplete = (key) => {
      setCompleted((c) => ({ ...c, [key]: true }));
    };

    const resetAfter = (key) => {
      const order = ["access", "personal", "address"];
      const idx = order.indexOf(key);
      setCompleted((c) =>
        order.reduce(
          (acc, k, i) => ({
            ...acc,
            [k]: i <= idx ? c[k] : false,
          }),
          {}
        )
      );
    };

    const handleNext = async () => {
      // console.log("activeIndex", activeIndex);
      if (activeIndex === 0) {
        accessRef.current?.submit();
      }
      if (activeIndex === 1) {
        personalRef.current?.submit();
      }
      if (activeIndex === 2) {
        addressRef.current?.submit();
      }
      if (activeIndex === 3) {
        bondRef.current?.submit();
      }
    };

    const handleSave = async () => {
      const accessData = accessRef.current?.getValues();
      const dataPersonal = personalRef.current?.getValues();
      const addressData = addressRef.current?.getValues();

      const rawBirth = dataPersonal?.date_of_birth;
      const rawIssuing = dataPersonal?.date_issuing_authority;

      function isValidDateString(d) {
        return typeof d === "string" && !isNaN(Date.parse(d));
      }

      function isValidDateObject(d) {
        return d instanceof Date && !isNaN(d.getTime());
      }

      const formattedBirth = rawBirth
        ? isValidDateObject(rawBirth)
          ? rawBirth.toISOString().slice(0, 10)
          : isValidDateString(rawBirth)
          ? rawBirth.split("T")[0]
          : ""
        : "";

      const formattedIssuing = rawIssuing
        ? isValidDateObject(rawIssuing)
          ? rawIssuing.toISOString().slice(0, 10)
          : isValidDateString(rawIssuing)
          ? rawIssuing.split("T")[0]
          : ""
        : "";
      const formattedData = {
        name: dataPersonal?.name || "",
        doc: dataPersonal?.doc || "",
        type_doc: typeRegister === "fisica" ? "1" : "2",
        creci: accessData?.creci || "",
        crc: accessData?.crc || "",
        rg: dataPersonal?.rg || "",
        issuing_authority: dataPersonal?.issuing_authority || "",
        state_registration: dataPersonal?.marital_status || "",
        municipal_registration: dataPersonal?.municipal_registration || "",
        state_registration: dataPersonal?.state_registration || "",
        name_mother: dataPersonal?.name_mother || "",
        name_father: dataPersonal?.name_father || "",
        family_income: dataPersonal?.family_income || "",
        date_of_birth: formattedBirth,
        date_issuing_authority: formattedIssuing,
        nationality: dataPersonal?.nationality || "",
        marital_status: dataPersonal?.marital_status || "",
        spouse_id: dataPersonal?.spouse_id || "",
        profession: dataPersonal?.profession || "",
        obs: dataPersonal?.obs || "",
        registration_types:
          accessData?.registration_types?.map((type) => type.code) || [],
        contacts:
          telephones?.filter((phone) => phone.number && phone.type_number)
            .length > 0
            ? telephones.map((phone) => ({
                number: phone.number,
                type_number: phone.type_number,
              }))
            : undefined,
        addresses: {
          cep: addressData?.cep || "",
          address: addressData?.address || "",
          num: addressData?.num || "",
          neighborhood: addressData?.neighborhood || "",
          city: addressData?.city || "",
          state: addressData?.state || "",
          complement: addressData?.complement || "",
        },
        documents: [],
      };

      if (accessData?.email) {
        formattedData.email = accessData.email;
      }

      if (accessData?.access_id) {
        formattedData.role_id = accessData.access_id;
      }

      if (!formattedData.contacts) {
        delete formattedData.contacts;
      }

      if (typeRegister === "juridica") {
        formattedData.cod_inc_trib = cumulativeTooltip;
      }

      // 🔍 Adiciona os documentos existentes (sem `id`)
      if (Array.isArray(documents) && documents.length > 0) {
        documents.forEach((doc) => {
          const { name, file, type_file } = doc;
          formattedData.documents.push({ name, type_file, file });
        });
      }

      // Foto de perfil
      if (file) {
        formattedData.documents.push({
          name: "Perfil",
          type_file: "cadastro_geral_profile_photo",
          file: file,
        });
      }

      if (cpf) {
        const index = formattedData.documents.findIndex(
          (doc) => doc.type_file === "cadastro_geral_cpf"
        );
        const docCpf = {
          name: "CPF",
          type_file: "cpf",
          file: cpf,
        };
        if (index !== -1) {
          formattedData.documents[index] = docCpf;
        } else {
          formattedData.documents.push(docCpf);
        }
      }

      // Comprovante de residência
      if (proofResidence) {
        const index = formattedData.documents.findIndex(
          (doc) => doc.type_file === "cadastro_geral_proof_residence"
        );
        const docProof = {
          name: "Comp. Residência",
          type_file: "proof_residence",
          file: proofResidence,
        };
        if (index !== -1) {
          formattedData.documents[index] = docProof;
        } else {
          formattedData.documents.push(docProof);
        }
      }

      // Contrato social
      if (socialContract) {
        const index = formattedData.documents.findIndex(
          (doc) => doc.type_file === "cadastro_geral_social_contract"
        );
        const docContract = {
          name: "Contrato Social",
          type_file: "social_contract",
          file: socialContract,
        };
        if (index !== -1) {
          formattedData.documents[index] = docContract;
        } else {
          formattedData.documents.push(docContract);
        }
      }

      try {
        await handleSubmit(formattedData);
        onHide();
        setCompleted({
          access: false,
          personal: false,
          address: false,
        });
        setCpf("");
        setProofResidence("");
        setSocialContract("");
        setBond([]);
        setActiveIndex(0);
      } catch (error) {
        console.error("Error saving data:", error);
      }
    };

    const handleEdit = async () => {
      const accessData = accessRef.current?.getValues();
      const dataPersonal = personalRef.current?.getValues();
      const addressData = addressRef.current?.getValues();
      const bondData = bondRef.current?.getValues();

      const rawBirth = dataPersonal?.date_of_birth;
      const rawIssuing = dataPersonal?.date_issuing_authority;

      function isValidDateString(d) {
        return typeof d === "string" && !isNaN(Date.parse(d));
      }

      function isValidDateObject(d) {
        return d instanceof Date && !isNaN(d.getTime());
      }

      const formattedBirth = rawBirth
        ? isValidDateObject(rawBirth)
          ? rawBirth.toISOString().slice(0, 10)
          : isValidDateString(rawBirth)
          ? rawBirth.split("T")[0]
          : ""
        : "";

      const formattedIssuing = rawIssuing
        ? isValidDateObject(rawIssuing)
          ? rawIssuing.toISOString().slice(0, 10)
          : isValidDateString(rawIssuing)
          ? rawIssuing.split("T")[0]
          : ""
        : "";

      const formattedData = {
        name: dataPersonal?.name || "",
        doc: dataPersonal?.doc || "",
        type_doc: typeRegister === "fisica" ? "1" : "2",
        creci: accessData?.creci || "",
        crc: accessData?.crc || "",
        rg: dataPersonal?.rg || "",
        issuing_authority: dataPersonal?.issuing_authority || "",
        state_registration: dataPersonal?.marital_status || "",
        municipal_registration: dataPersonal?.municipal_registration || "",
        state_registration: dataPersonal?.state_registration || "",
        name_mother: dataPersonal?.name_mother || "",
        name_father: dataPersonal?.name_father || "",
        family_income: dataPersonal?.family_income || "",
        date_of_birth: formattedBirth,
        date_issuing_authority: formattedIssuing,
        nationality: dataPersonal?.nationality || "",
        marital_status: dataPersonal?.marital_status || "",
        spouse_id: dataPersonal?.spouse_id || "",
        profession: dataPersonal?.profession || "",
        obs: dataPersonal?.obs || "",
        registration_types:
          accessData?.registration_types?.map((type) => type.code) || [],
        contacts:
          telephones?.filter((phone) => phone.number && phone.type_number)
            .length > 0
            ? telephones.map((phone) => ({
                number: phone.number,
                type_number: phone.type_number,
                ...( phone.id ? { id: phone.id } : {})
              }))
            : undefined,
        addresses: {
          cep: addressData?.cep || "",
          address: addressData?.address || "",
          num: addressData?.num || "",
          neighborhood: addressData?.neighborhood || "",
          city: addressData?.city || "",
          state: addressData?.state || "",
          complement: addressData?.complement || "",
        },
        documents: [],
      };

      if (accessData?.email) {
        formattedData.email = accessData.email;
      }

      if(accessData.status){
        formattedData.status = 1;
      } else {
        formattedData.status = 0;
      }

      if (accessData?.access_id) {
        formattedData.role_id = accessData.access_id;
      } else if (accessId !== null) {
        formattedData.role_id = null;
      }

      if (typeRegister === "juridica") {
        formattedData.cod_inc_trib = cumulativeTooltip;
      }

      if (Array.isArray(documents) && documents.length > 0) {
        formattedData.documents = documents.map((doc) => {
          if (doc.hasOwnProperty("id") && Number.isInteger(doc.id)) {
            return {
              id: doc.id,
              name: doc.name,
              type_file: doc.type_file,
            };
          } else {
            return {
              name: doc.name,
              type_file: doc.type_file,
              file: doc.file,
            };
          }
        });
      }

      // Foto de perfil
      const existingProfile = documents?.find(
        (doc) => doc.type_file === "cadastro_geral_profile_photo"
      );

      const isFileEdited =
        typeof file !== "string" || file !== existingProfile?.path;

      if (existingProfile && !isFileEdited) {
        formattedData.documents = formattedData.documents.filter(
          (doc) => doc.type_file !== "cadastro_geral_profile_photo"
        );

        formattedData.documents.push({
          id: existingProfile.id,
          name: existingProfile.name || "Perfil",
          type_file: existingProfile.type_file,
          file: existingProfile.file,
        });
      } else if (file) {
        formattedData.documents = formattedData.documents.filter(
          (doc) => doc.type_file !== "cadastro_geral_profile_photo"
        );

        formattedData.documents.push({
          name: "Perfil",
          type_file: "cadastro_geral_profile_photo",
          file: file,
        });
      }

      // CPF
      if (cpf) {
        const index = formattedData.documents.findIndex(
          (doc) => doc.type_file === "cadastro_geral_cpf"
        );
        const docCpf = {
          name: "CPF",
          type_file: "cadastro_geral_cpf",
          file: cpf,
        };
        if (index !== -1) {
          formattedData.documents[index] = docCpf;
        } else {
          formattedData.documents.push(docCpf);
        }
      }

      // Comprovante de residência
      if (proofResidence) {
        const index = formattedData.documents.findIndex(
          (doc) => doc.type_file === "cadastro_geral_proof_residence"
        );
        const docProof = {
          name: "Comp. Residência",
          type_file: "cadastro_geral_proof_residence",
          file: proofResidence,
        };
        if (index !== -1) {
          formattedData.documents[index] = docProof;
        } else {
          formattedData.documents.push(docProof);
        }
      }

      // Contrato social
      if (socialContract) {
        const index = formattedData.documents.findIndex(
          (doc) => doc.type_file === "cadastro_geral_social_contract"
        );
        const docContract = {
          name: "Contrato Social",
          type_file: "cadastro_geral_social_contract",
          file: socialContract,
        };
        if (index !== -1) {
          formattedData.documents[index] = docContract;
        } else {
          formattedData.documents.push(docContract);
        }
      }

      if (!formattedData.contacts) {
        delete formattedData.contacts;
      }

      try {
        await handleUpdate(formattedData, bondData);
        onHide();
        setCompleted({
          access: false,
          personal: false,
          address: false,
        });
        setCpf("");
        setProofResidence("");
        setSocialContract("");
        setBond([]);
        setActiveIndex(0);
      } catch (error) {
        console.error("Error saving data:", error);
      }
    };

    const onTabChange = (e) => {
      setActiveIndex(e.index);
    };

    useEffect(() => {
      handleInputRequired();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      if (baseData) {
        setAddress(baseData?.address);
        if (baseData?.phone) {
          setTelephones([{ number: baseData?.phone, type_number: 1 }]);
          setContacts([{ number: baseData?.phone, type_number: 1 }]);
        }
      }
    }, [baseData]);

    useEffect(() => {
      if (editClient) {
        setActiveIndex(0);
        setCompleted({
          access: true,
          personal: true,
          address: true,
        });
      } else {
        setActiveIndex(0);
        setCompleted({
          access: false,
          personal: false,
          address: false,
        });
      }
    }, [editClient]);

    return (
      <>
        <Modal
          dynamicTitle="Cadastro Geral"
          dynamicWidth={window.innerWidth >= 992 ? "70vw" : "90vw"}
          visible={visible}
          onHide={() => {
            onHide();
            setCompleted({
              access: false,
              personal: false,
              address: false,
            });
            setBond([]);
            setCpf("");
            setProofResidence("");
            setSocialContract("");
            setActiveIndex(0);
          }}
          footer={
            <div className="row pt-3">
              {loadingModal ? (
                <>
                  <div className="col-6 text-start">
                    {activeIndex > 0 && (
                      <Button
                        label="Anterior"
                        icon="fa-regular fa-circle-left"
                        className="p-button-text"
                        onClick={() => setActiveIndex((i) => i - 1)}
                      />
                    )}
                  </div>
                  <div className="col-6 d-flex justify-content-end pe-3">
                    <Skeleton width="120px" height="50px" />
                  </div>
                </>
              ) : (
                <>
                  <div className="col-6 text-start">
                    {activeIndex > 0 && (
                      <Button
                        label="Anterior"
                        icon="fa-regular fa-circle-left"
                        className="p-button-text"
                        onClick={() => setActiveIndex((i) => i - 1)}
                      />
                    )}
                  </div>
                  <div className="col-6 text-end">
                    {(editClient || (!editClient && activeIndex === 3)) && (
                      <Button
                        label="Salvar"
                        icon="fa-solid fa-floppy-disk"
                        severity="info"
                        className="p-button-text me-3"
                        iconPos="left"
                        loading={loading}
                        onClick={editClient ? handleEdit : handleSave}
                      />
                    )}

                    {activeIndex < (editClient && bond?.length > 0 ? 4 : 3) && (
                      <Button
                        label="Próximo"
                        icon="fa-regular fa-circle-right"
                        className="p-button-text"
                        iconPos="right"
                        onClick={handleNext}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          }
        >
          {loadingModal ? (
            <div className="row mt-2 w-100">
              <div className="row px-3 justify-content-start">
                <div className="col-md-2 d-flex justify-content-center">
                  <Skeleton width="70%" height="30px"></Skeleton>
                </div>
                <div className="col-md-2 d-flex justify-content-center">
                  <Skeleton width="70%" height="30px"></Skeleton>
                </div>
                <div className="col-md-2 d-flex justify-content-center">
                  <Skeleton width="70%" height="30px"></Skeleton>
                </div>
                <div className="col-md-2 d-flex justify-content-center">
                  <Skeleton width="70%" height="30px"></Skeleton>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
                <div className="col-md-6 my-4">
                  <Skeleton width="100%" height="50px"></Skeleton>
                </div>
              </div>
            </div>
          ) : (
            <>
              {editClient && bond?.length > 0 ? (
                <TabView
                  activeIndex={activeIndex}
                  onTabChange={onTabChange}
                  renderActiveOnly={false}
                >
                  <TabPanel header="Acesso" leftIcon="fa-solid fa-user mx-2">
                    <Access
                      ref={accessRef}
                      access={access}
                      baseData={baseData}
                      editClient={editClient}
                      emailSend={emailSend}
                      emailVerify={emailVerify}
                      showInputCrc={showInputCrc}
                      showInputCreci={showInputCreci}
                      showStatusUser={showStatusUser}
                      setShowInputCrc={setShowInputCrc}
                      setShowStatusUser={setShowStatusUser}
                      setShowInputCreci={setShowInputCreci}
                      onSubmitAccess={(data) => {
                        handleAccessSubmit(data);
                        markComplete("access");
                      }}
                      onDirty={(isDirty) => isDirty && resetAfter("access")}
                    />
                  </TabPanel>

                  <TabPanel
                    header="Pessoais"
                    leftIcon="fa-solid fa-id-card mx-2"
                    disabled={!completed.access}
                  >
                    <PersonalData
                      file={file}
                      spouse={spouse}
                      ref={personalRef}
                      setFile={setFile}
                      contacts={contacts}
                      baseData={baseData}
                      setSpouse={setSpouse}
                      editClient={editClient}
                      setAddress={setAddress}
                      telephones={telephones}
                      setContacts={setContacts}
                      typeRegister={typeRegister}
                      personalData={personalData}
                      setTelephones={setTelephones}
                      setTypeRegister={setTypeRegister}
                      cumulativeTooltip={cumulativeTooltip}
                      setCumulativeTooltip={setCumulativeTooltip}
                      onSubmitPersonal={(data) => {
                        handlePersonalSubmit(data);
                        markComplete("personal");
                      }}
                      onDirty={(isDirty) => isDirty && resetAfter("personal")}
                    />
                  </TabPanel>

                  <TabPanel
                    header="Endereço"
                    leftIcon="fa-solid fa-map mx-2"
                    disabled={!completed.personal}
                  >
                    <Address
                      ref={addressRef}
                      address={address}
                      baseData={baseData}
                      onSubmitAddress={(data) => {
                        handleAddressSubmit(data);
                        markComplete("address");
                      }}
                      onDirty={(isDirty) => isDirty && resetAfter("address")}
                    />
                  </TabPanel>

                  <TabPanel
                    header="Vínculos"
                    leftIcon="fa-solid fa-link mx-2"
                    disabled={!completed.address || bond?.length === 0}
                  >
                    <Bond
                      ref={bondRef}
                      bond={bond}
                      onSubmitBond={(data) => {
                        setActiveIndex((i) => i + 1);
                        console.log("Bond Data:", data);
                        console.log(
                          "Bond Values:",
                          bondRef?.current?.getValues()
                        );
                      }}
                    />
                  </TabPanel>

                  <TabPanel
                    header="Documentos"
                    leftIcon="fa-solid fa-file mx-2"
                    disabled={!completed.address}
                  >
                    <Documents
                      cpf={cpf}
                      setCpf={setCpf}
                      ref={documentsRef}
                      baseData={baseData}
                      documents={documents}
                      typeRegister={typeRegister}
                      setDocuments={setDocuments}
                      proofResidence={proofResidence}
                      socialContract={socialContract}
                      setProofResidence={setProofResidence}
                      setSocialContract={setSocialContract}
                    />
                  </TabPanel>
                </TabView>
              ) : (
                <TabView
                  activeIndex={activeIndex}
                  onTabChange={onTabChange}
                  renderActiveOnly={false}
                >
                  <TabPanel header="Acesso" leftIcon="fa-solid fa-user mx-2">
                    <Access
                      ref={accessRef}
                      access={access}
                      baseData={baseData}
                      emailSend={emailSend}
                      editClient={editClient}
                      emailVerify={emailVerify}
                      showInputCrc={showInputCrc}
                      showStatusUser={showStatusUser}
                      showInputCreci={showInputCreci}
                      setShowInputCrc={setShowInputCrc}
                      setShowStatusUser={setShowStatusUser}
                      setShowInputCreci={setShowInputCreci}
                      onSubmitAccess={(data) => {
                        handleAccessSubmit(data);
                        markComplete("access");
                      }}
                      onDirty={(isDirty) => isDirty && resetAfter("access")}
                    />
                  </TabPanel>

                  <TabPanel
                    header="Pessoais"
                    leftIcon="fa-solid fa-id-card mx-2"
                    disabled={!completed.access}
                  >
                    <PersonalData
                      file={file}
                      spouse={spouse}
                      ref={personalRef}
                      setFile={setFile}
                      contacts={contacts}
                      baseData={baseData}
                      setSpouse={setSpouse}
                      editClient={editClient}
                      setAddress={setAddress}
                      telephones={telephones}
                      setContacts={setContacts}
                      typeRegister={typeRegister}
                      personalData={personalData}
                      setTelephones={setTelephones}
                      setTypeRegister={setTypeRegister}
                      cumulativeTooltip={cumulativeTooltip}
                      setCumulativeTooltip={setCumulativeTooltip}
                      onSubmitPersonal={(data) => {
                        handlePersonalSubmit(data);
                        markComplete("personal");
                      }}
                      onDirty={(isDirty) => isDirty && resetAfter("personal")}
                    />
                  </TabPanel>

                  <TabPanel
                    header="Endereço"
                    leftIcon="fa-solid fa-map mx-2"
                    disabled={!completed.personal}
                  >
                    <Address
                      ref={addressRef}
                      address={address}
                      baseData={baseData}
                      onSubmitAddress={(data) => {
                        handleAddressSubmit(data);
                        markComplete("address");
                      }}
                      onDirty={(isDirty) => isDirty && resetAfter("address")}
                    />
                  </TabPanel>

                  <TabPanel
                    header="Documentos"
                    leftIcon="fa-solid fa-file mx-2"
                    disabled={!completed.address}
                  >
                    <Documents
                      cpf={cpf}
                      setCpf={setCpf}
                      ref={documentsRef}
                      baseData={baseData}
                      documents={documents}
                      typeRegister={typeRegister}
                      setDocuments={setDocuments}
                      proofResidence={proofResidence}
                      socialContract={socialContract}
                      setProofResidence={setProofResidence}
                      setSocialContract={setSocialContract}
                    />
                  </TabPanel>
                </TabView>
              )}
            </>
          )}
        </Modal>
        <Modal
          visible={errorsVisible}
          position="center"
          onHide={() => setErrorsVisible(false)}
          dynamicTitle="Inconsistências Encontradas"
        >
          {errors &&
            Object.keys(errors).map((key) => {
              const error = errors[key];
              console.log("Error: ", error);
              return error.map((text, index) => (
                <div
                  key={index}
                  className="card mb-3 p-3 bg-red-400 rounded-3 bg-opacity-75"
                >
                  {console.log("Error Key:", key)}
                  <h4 className="text-center d-flex align-items-center my-auto">
                    <i
                      className="fa-solid fa-triangle-exclamation me-2"
                      style={{ fontSize: "1.5em" }}
                    ></i>
                    {text}
                  </h4>
                </div>
              ));
            })}
          <div className="d-flex justify-content-center pt-3">
            <Button
              label="Corrigir"
              icon="fa-solid fa-pen"
              onClick={() => handleClickEditErrors()}
              autoFocus
            />
          </div>
        </Modal>
      </>
    );
  }
);

export default ModalRegister;
